import React from 'react';
import "./Styles/ErrorPages.css";
import NavBar from '../NavBar';
import Error404 from './Components/ErrorPages/Error404';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import UserInfoProvider from './Components/Context/UserInfoContext';
import MedicalContextProvider from './Components/Context/MedicalContext';
import PacksProvider from './Components/Context/PacksContext';

function Error404Route() {
    return (
        <UserInfoProvider>
            <MedicalContextProvider>
                <PacksProvider>
                    <div className="Error404RoutePage">
                        <div className="Error404RouteNavBar">      
                            <NavBar/>
                        </div>
                        <div className="Error404Route">
                            <Error404/>
                        </div>
                    </div>
                </PacksProvider>
            </MedicalContextProvider>
       </UserInfoProvider>
    );
}

export default Error404Route;